import { useTranslation } from "react-i18next";
import { UploadOutlined } from "@ant-design/icons";
import { Flex } from "antd";

import type { UploadFileExtended } from "@av/apps/public/jobs/services/apply/types";
import { MAX_SUPPORTING_DOCUMENTS_COUNT } from "@av/apps/recruitment/ats-common/services/document-upload-validation";
import { Button } from "@av/components/atoms/Button";
import { UploadedDocumentFileRow } from "./UploadedDocumentFileRow";

import type { UploadFile } from "antd/es/upload/interface";

type SupportingDocumentsUploadFieldProps = {
  value?: UploadFileExtended[];
  onChange?: (files: UploadFileExtended[]) => void;
  onUploadClick: () => void;
  onReplace: (file: UploadFileExtended, replacementFile: UploadFile) => void;
  disabled?: boolean;
};

export function SupportingDocumentsUploadField({
  value = [],
  onChange,
  onUploadClick,
  onReplace,
  disabled,
}: SupportingDocumentsUploadFieldProps) {
  const { t } = useTranslation();

  return (
    <Flex vertical gap={8}>
      {value.map((file) => (
        <UploadedDocumentFileRow
          key={file.uid}
          file={file}
          onReplace={(replacementFile) => onReplace(file, replacementFile)}
          onRemove={() => onChange?.(value.filter(({ uid }) => uid !== file.uid))}
        />
      ))}
      {value.length < MAX_SUPPORTING_DOCUMENTS_COUNT ? (
        <Flex>
          <Button
            testIdPrefix="candidate-application-supporting-documents-upload"
            icon={<UploadOutlined />}
            size="middle"
            disabled={disabled}
            onClick={onUploadClick}
          >
            {value.length > 0
              ? t("recruitment.jobApplication.documents_uploadMore")
              : t("recruitment.jobApplication.addButton")}
          </Button>
        </Flex>
      ) : null}
    </Flex>
  );
}
